<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{ responseError }}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="code"
                  label="Code"
                  v-model="customer.code"
                  type="text"
                  :rules="rules.codeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Name"
                  v-model="customer.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="phoneNo"
                  label="PhoneNo"
                  v-model="customer.phoneNo"
                  type="text"
                  :rules="rules.phoneNoRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="email"
                  label="Email"
                  v-model="customer.email"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-select
                  :items="creditLevelList"
                  v-model="customer.creditLevelId"
                  label="Choose Credit Level"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :rules="rules.creditLevelRules"
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-select
                  :items="customerTypes"
                  label="Customer Type"
                  v-model="customer.customerType"
                  item-text="label"
                  item-value="value"
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-textarea
                  name="address"
                  label="Address"
                  v-model="customer.address"
                  type="text"
                  :rules="rules.addressRules"
                ></v-textarea>
              </v-flex>
              <v-flex sm12 v-if="customer.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="customer.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="customer.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="customer.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="customer.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="customer.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid"
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { customerService } from "../../services/customer-service";
import { creditLevelService } from "../../services/credit-level-service";
import { Customer } from "../../models/model";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { CustomerFormRules } from "../../helpers/validation-rules";
import { commonService } from "../../services/common-service";

export default {
  name: "CustomerDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "Customer",
        disabled: false,
        to: "customers",
      },
      {
        text: "Customer Detail",
        disabled: true,
      },
    ],
    createdDate: "",
    updatedDate: "",
    customer: new Customer(),
    oldCustomer: new Customer(),
    saveLoading: false,
    responseError: "",
    rules: new CustomerFormRules(),
    creditLevelList: [],
    customerTypes: [],
  }),
  created() {
    const id = this.$route.params.id;
    this.getCreditLevels();
    this.getAllCustomerTypes();
    if (id == "new") {
      // new Customer
    } else {
      this.getCustomerDetail(id);
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        customerService
          .saveCustomer(this.customer)
          .then((res) => {
            console.log(res);
            this.goBack();
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getCustomerDetail(id) {
      customerService
        .getCustomerDetail(id)
        .then((res) => {
          this.customer = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.customer.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.customer.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );

          this.oldCustomer = Object.assign({}, res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCreditLevels() {
      creditLevelService
        .getCreditLevels()
        .then((res) => {
          if (res.data) {
            this.creditLevelList = res.data.creditLevelList;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.customer.id) {
        this.customer = new Customer();
      } else {
        this.customer = Object.assign({}, this.oldCustomer);
      }
    },
    goBack() {
      this.$router.push("/customers");
    },
    getAllCustomerTypes() {
      customerService
        .getAllCustomerTypes()
        .then((res) => {
          let tempList = res.data;
          for (let temp of tempList) {
            let tempObj = {
              label: temp,
              value: temp,
            };

            this.customerTypes.push(tempObj);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

